import { Box, Grid, Typography } from '@mui/material';
import { makeStyles, styled } from '@mui/styles';
import { Stack } from '@mui/system';
import React, { useState, useEffect } from 'react';
import ContainedButton from '../../../components/actions/ContainedButton';
import ErrorAlert from '../../../components/alerts/ErrorAlert';
import InputForm from '../../../components/forms/InputForm';
import BaseModal from '../../../components/modals/BaseModal';
import useUser from '../../../hooks/api/useUser';
import useForm from '../../../hooks/useForm';
import { GENDERS, LANGUAGES } from '../../../utils/enums';
import moment from 'moment-timezone';
import CeluIcon from '../../../components/platform/CeluIcon';
import cartIcon from '../../../assets/icons/ecommerce/shopping-cart.svg'
import useCart from '../../../hooks/api/useCart';
import { useSnackbar } from 'notistack';
const StyledRoot = styled('div')(({ theme }) => ({
    //right: 0,
    //bottom: 0,
    //zIndex: 9998,
    width: '100%',
    minHeight: '30vh',
    //position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
  }));

const AssignUser2CartModal = (props) => {

    const {open, onClose, cart, onCompleted} = props
    const { enqueueSnackbar } = useSnackbar();
    const  classes = useStyles()
    const [sending, setSending] = useState(false)
    const [error, setError] = useState()
    const cartManager = useCart()
    const controller = useForm(form_data)
    const {form, onChangeForm, onResetForm, onGetFormData} = controller


    useEffect(() => {
        if(!open) onResetForm()
    },[open])

    const onSubmit = async() => {


        setSending(true)
        const data2send = onGetFormData()

        try {
            console.log('Send data', cart?.id_cart, data2send)
            const _data = {
                web_id:data2send?.web_id?.toUpperCase(),
                cart_id:cart?.id_cart
            }
            await cartManager.actions.onAssignUser(data2send?.user_id, _data)
            //console.log(response)
            //await onCompleted({id_cart:response})
            //await onRefresh()
            onClose()
            enqueueSnackbar('Carrito asignado exitosamente', {variant:"success"})
            

        } catch (error) {
            setError(error)
            setSending(false)
            return
        }

        setSending(false)
        onClose()

    }

    return ( 
        <BaseModal maxWidth='xs'
        title='Asignar carrito'
        open={open} 
        onClose={onClose} >
            <StyledRoot>
                <div>
                    <Stack alignItems='center' spacing={2}>
                        <div>
                            <CeluIcon size='large' icon={cartIcon}/>
                        </div>
                        <Typography variant='body1' align='center' sx={{maxWidth:300}} >
                            <i>Ingrese los datos solicitados del paciente para que se pueda asignar este carrito a su cuenta</i>
                        </Typography>
                        <Box sx={{marginTop:4, marginBottom:16, width:'100%'}}>
                            <InputForm data={form.user_id} onChange={onChangeForm}/>
                        </Box>
                        <Box sx={{marginTop:4, marginBottom:16, width:'100%'}}>
                            <InputForm data={form.web_id} onChange={onChangeForm}/>
                        </Box>
                        {error && 
                            <ErrorAlert 
                            error={error} 
                            onClose={() => setError(null)} />
                        }
                        <ContainedButton fullWidth disabled={!form?.user_id?.isValid || !form?.web_id?.isValid} loading={sending} onClick={onSubmit}>
                            Asignar
                        </ContainedButton>
                    </Stack>
                </div>
            </StyledRoot>
        </BaseModal>
     );
}

const useStyles = makeStyles(theme => ({
    description:{
        marginBottom:16
    }
}))
 
export default AssignUser2CartModal;

const form_data = {
    user_id: {
        value:'',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'user_id',
            type: 'text',
            fullWidth: true,
            label:'ID de paciente',
            placeholder:'ID de paciente',
            helperText:'Debe de contener de 1 a 255 caracteres '
        },
        rules: {type: 'distance', min:1, max:255}
    },
    web_id: {
        value:'',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'web_id',
            type: 'text',
            fullWidth: true,
            label:'Código de paciente',
            placeholder:'Código de paciente',
            helperText:'Debe de contener de 1 a 255 caracteres '
        },
        rules: {type: 'distance', min:1, max:255}
    },
}

